import React, { useContext, useEffect, useState } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { useDropzone } from "react-dropzone";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import CloseIcon from "@mui/icons-material/Close";
import cameraIcon from "../../assets/svg/camera.svg";
import removeImgIcon from "../../assets/svg/remove_img.svg";
import StoreStepperContext from "../../context/storeStepperContext";
import { getDownloadURL, ref } from "firebase/storage";
import { storage } from "../../firebaseConfig";

const MAX_FILE_SIZE = 25 * 1024 * 1024; // 25MB

const FileUploadNewVersion = ({
  onChange,
  imgWidth = "80px",
  imgHeight = "80px",
  maxFileNum = 6,
  typePage,
}) => {
  const [files, setFiles] = useState([]);
  const [resolvedFiles, setResolvedFiles] = useState([]);
  const { storeformData, setStoreFormData, checkForEdit } =
    useContext(StoreStepperContext);

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    const filteredFiles = selectedFiles.filter(
      (file) =>
        file.size <= MAX_FILE_SIZE &&
        (file.type.startsWith("image/") || file.type.startsWith("video/"))
    );
    const newFiles = [...files, ...filteredFiles].slice(0, maxFileNum);

    setFiles(newFiles);

    if (onChange) {
      onChange(newFiles);
    }

    event.target.value = "";
  };

  const handleRemoveFile = (index) => {
    const updatedFiles = [...files];
    updatedFiles.splice(index, 1);
    setFiles(updatedFiles);

    const updatedUrls = storeformData?.currentProduct?.productImage.filter(
      (_, i) => i !== index
    );

    setStoreFormData((prev) => ({
      ...prev,
      currentProduct: {
        ...prev.currentProduct,
        productImage: updatedUrls,
      },
    }));
  };

  const handleRemoveFileFirebase = (index) => {
    resolvedFiles.splice(index, 1);

    const updatedUrls = storeformData?.currentProduct?.productImage.filter(
      (_, i) => i !== index
    );

    setResolvedFiles(updatedUrls);

    setStoreFormData((prev) => ({
      ...prev,
      currentProduct: {
        ...prev.currentProduct,
        productImage: updatedUrls,
      },
    }));
  };

  const renderFilePreview = (file) => {
    if (typeof file === "string") {
      return (
        <img
          src={file}
          alt="Preview"
          style={{
            width: imgWidth,
            height: imgHeight,
            objectFit: "cover",
          }}
        />
      );
    }
    if (file.type.startsWith("image")) {
      return (
        <img
          src={URL.createObjectURL(file)}
          alt="Preview"
          style={{
            width: imgWidth,
            height: imgHeight,
            objectFit: "cover",
          }}
        />
      );
    }
    return (
      <video
        controls
        style={{
          width: imgWidth,
          height: imgHeight,
          objectFit: "cover",
        }}
      >
        <source src={URL.createObjectURL(file)} type={file.type} />
        Your browser does not support the video tag.
      </video>
    );
  };

  useEffect(() => {
    const resolveFiles = async () => {
      if (storeformData?.currentProduct?.productImage?.length > 0) {
        const resolved = await Promise.all(
          storeformData.currentProduct.productImage.map(async (file) => {
            const fileRef = ref(storage, file); // Reference to Firebase Storage
            return await getDownloadURL(fileRef); // Fetch URL
          })
        );
        setResolvedFiles(resolved); // Store resolved URLs
      }
    };

    const resolveFiles2 = async () => {
      if (resolvedFiles > 0) {
        const resolved = await Promise.all(
          resolvedFiles.map(async (file) => {
            const fileRef = ref(storage, file); // Reference to Firebase Storage
            return await getDownloadURL(fileRef); // Fetch URL
          })
        );
        setResolvedFiles(resolved); // Store resolved URLs
      }
    };

    if (
      checkForEdit === true &&
      storeformData?.currentProduct?.productImage?.length > 0 &&
      files?.length <= 0
    ) {
      resolveFiles();
    }

    if (
      checkForEdit === true &&
      storeformData?.currentProduct?.productImage?.length > 0 &&
      files?.length >= 0
    ) {
      resolveFiles2();
    }
  }, [storeformData?.currentProduct?.productImage]);

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          gap: "10px",
          alignItems: "center",
        }}
      >
        {files?.length > 0 || checkForEdit ? (
          <label htmlFor="file-input" style={{ cursor: "pointer" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: imgWidth,
                height: imgHeight,
                border: "1px solid rgba(241, 241, 241, 1)",
                cursor: "pointer",
                backgroundColor: "rgba(241, 241, 241, 1)",
              }}
            >
              <input
                id="file-input"
                type="file"
                accept="image/*,video/*"
                multiple
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
              <PhotoCamera
                sx={{ width: "24px", height: "24px", color: "#959BA1" }}
              />
            </Box>
          </label>
        ) : (
          <Box
            sx={{
              backgroundColor: "rgba(241, 241, 241, 1)",
              height: "156px",
              mt: "24px",
              width: typePage === "storeDetail" ? "160px" : "23vw",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={cameraIcon}
                  width="40px"
                  height="40px"
                  alt="camera_icon"
                />
              </Box>
              {typePage !== "storeDetail" && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: "15px",
                  }}
                >
                  <Typography>Upload Image or video. Max size 25 MB</Typography>
                </Box>
              )}
              <Box
                sx={{
                  cursor: "pointer",
                  height: "35px",
                  justifyContent: "center",
                  display: "flex",
                  alignItems: "center",
                  marginTop: "16px",
                }}
              >
                <label
                  htmlFor="file-input"
                  style={{
                    cursor: "pointer",
                    backgroundColor: "#FFF",
                    height: "35px",
                    width: "126px",
                    justifyContent: "center",
                    display: "flex",
                    textAlign: "center",
                    alignItems: "center",
                    fontWeight: 600,
                    fontSize: "14px",
                  }}
                >
                  <input
                    id="file-input"
                    type="file"
                    accept="image/*,video/*"
                    multiple
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                  />
                  Upload
                </label>
              </Box>
            </Box>
          </Box>
        )}
        {checkForEdit === true &&
          resolvedFiles?.length > 0 &&
          resolvedFiles?.map((file, index) => (
            <Box
              key={index}
              sx={{
                position: "relative",
                width: imgWidth,
                height: imgHeight,
                marginRight: "!2px",
              }}
            >
              <img
                src={file}
                alt="Preview"
                style={{
                  width: imgWidth,
                  height: imgHeight,
                  objectFit: "cover",
                }}
              />
              <img
                src={removeImgIcon}
                alt="remove_img"
                style={{
                  position: "absolute",
                  top: "-5px",
                  right: "-5px",
                  cursor: "pointer",
                }}
                onClick={() => handleRemoveFileFirebase(index)}
              />
            </Box>
          ))}
        {files.map((file, index) => (
          <Box
            key={index}
            sx={{
              position: "relative",
              width: imgWidth,
              height: imgHeight,
              marginRight: "!2px",
            }}
          >
            {renderFilePreview(file)}
            <img
              src={removeImgIcon}
              alt="remove_img"
              style={{
                position: "absolute",
                top: "-5px",
                right: "-5px",
                cursor: "pointer",
              }}
              onClick={() => handleRemoveFile(index)}
            />
          </Box>
        ))}
      </Box>
      {files.length === 6 && (
        <Typography
          variant="caption"
          sx={{
            display: "block",
            textAlign: "center",
            marginTop: "8px",
            color: "#EB5757",
          }}
        >
          You can upload maximum 6 images.
        </Typography>
      )}
    </Box>
  );
};

export default FileUploadNewVersion;
